import { normalizedImageMimeType } from './imagePolicy'

function isImageClipboardFile(file: File): boolean {
  return file.type.toLowerCase().startsWith('image/')
    || normalizedImageMimeType(file) !== null
}

interface ClipboardFileData {
  files?: FileList | null
  items?: DataTransferItemList | null
}

function imageFilesFromItems(items: DataTransferItemList | null | undefined): File[] {
  return Array.from(items ?? [])
    .filter((item) => item.kind === 'file')
    .map((item) => item.getAsFile())
    .filter((file): file is File => file !== null && isImageClipboardFile(file))
}

/**
 * Reads image files exposed by a paste event. Chromium mirrors item files into
 * `files`, so prefer `items` and use `files` only as the Android/WebView fallback.
 */
export function clipboardImageFiles(
  clipboardData: ClipboardFileData,
): File[] {
  const itemFiles = imageFilesFromItems(clipboardData.items)
  if (itemFiles.length > 0) return itemFiles

  return Array.from(clipboardData.files ?? []).filter(isImageClipboardFile)
}
